
import { createApiClient } from 'Network/ApiClient';

export const ActivityToIcdsAxiosInstance = createApiClient('relation/');


